<!--
  정책 문서 버전 탭.
  URL 을 바꾸지 않는다 — 라우터를 건드리지 않고 부모의 로컬 state 만 토글한다 (Seven 확정, mimio#46).
  디자인은 서비스 소개(ServiceInfo.vue) 섹션 버튼을 가져오되, 정책 페이지는 배경이 어두우므로(body #151419)
  필/글자 색만 반전했다. 치수·라운드·폰트 두께는 원본 그대로.
-->
<template>
  <div class="policy-version-tabs">
    <div class="tab-group" role="tablist" :aria-label="ariaLabel">
      <button
          v-for="(version, index) in versions"
          :key="version.id"
          :ref="el => setTabRef(el, index)"
          type="button"
          role="tab"
          :aria-selected="modelValue === version.id ? 'true' : 'false'"
          :tabindex="modelValue === version.id ? 0 : -1"
          :class="{ active: modelValue === version.id }"
          @click="select(version.id)"
          @keydown="onKeydown($event, index)"
      >
        {{ version.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref } from 'vue';

const props = defineProps({
  // [{ id: 'latest', label: '최신 · 2026.09.07 시행' }, ...]
  versions: { type: Array, required: true },
  modelValue: { type: String, required: true },
  ariaLabel: { type: String, default: '문서 버전' },
});

const emit = defineEmits(['update:modelValue']);

const tabRefs = ref([]);
const setTabRef = (el, index) => {
  tabRefs.value[index] = el;
};

const select = (id) => {
  if (id !== props.modelValue) emit('update:modelValue', id);
};

// ARIA tabs 패턴 — 좌우 화살표로 전환, Home/End 로 양끝
const onKeydown = (event, index) => {
  const last = props.versions.length - 1;
  let next = null;
  if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
  else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
  else if (event.key === 'Home') next = 0;
  else if (event.key === 'End') next = last;
  if (next === null) return;

  event.preventDefault();
  select(props.versions[next].id);
  nextTick(() => tabRefs.value[next]?.focus());
};
</script>

<style scoped>
.policy-version-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 30px;
}

.tab-group {
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  align-items: center;
}

/* reset.css 가 button 에 color:#191919 를 박아둬서 어두운 배경에선 안 보인다 — 클래스 특이도로 덮는다 */
.tab-group button {
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  border-radius: 5px;
  padding: 11px 13px;
  transition: all 0.3s;

  font-weight: 500;
  font-size: 14px;
  text-align: center;
  letter-spacing: -0.3px;
  white-space: nowrap;
  color: #fff;
}

.tab-group button.active {
  background: #FFF3CE;
  border-color: #FFF3CE;
  font-weight: 600;
  color: #151419;
}

.tab-group button:focus-visible {
  outline: 2px solid #FFD353;
  outline-offset: 2px;
}

@media all and (max-width: 768px) {
  .policy-version-tabs {
    margin-bottom: 20px;
  }

  .tab-group {
    column-gap: 10px;
  }

  .tab-group button {
    font-size: 12px;
    padding: 8px 10px;
  }
}
</style>
